import React from "react";
import { Helmet } from "react-helmet-async";
import "./UserGuide.css";

function IndianPharmacies() {
  return (

    <div className="user-guide-page">

       {/* SEO META */}
      <Helmet>
        <title>Indian Pharmacies | Medicine Network & Online Pharmacy Guide</title>
        <meta
          name="description"
          content="Learn about Indian pharmacies, regulated medical stores, online medicine delivery, and safety tips for purchasing medicines in India."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://realgenericshop.com/indian-pharmacies" />
      </Helmet>

      <div className="user-guide-container">

        <h1 className="user-guide-title">
          Indian Pharmacies
        </h1>

        <div className="user-guide-content">

          <p>
            India has a well-established pharmaceutical network that ensures
            access to affordable and quality medicines across the country.
          </p>

          <h3>Key Highlights</h3>

          <ul>
            <li>Licensed and regulated medical stores</li>

            <li>
              Availability of generic and branded medicines
            </li>

            <li>
              Strict guidelines by health authorities
            </li>

            <li>
              Wide network across urban and rural areas
            </li>
          </ul>

          <h3>Online Pharmacies</h3>

          <p>
            Online pharmacies like MediCare make it easier to order medicines
            from the comfort of your home with doorstep delivery and verified
            products.
          </p>

          <h3>Safety Tips</h3>

          <ul>
            <li>
              Always buy from licensed pharmacies
            </li>

            <li>
              Check expiry date before use
            </li>

            <li>
              Avoid self-medication
            </li>
          </ul>

        </div>

      </div>

    </div>

  );
}

export default IndianPharmacies;